import { PropsWithChildren, ReactNode } from 'react';
import clsx from 'clsx';

type SectionCardProps = PropsWithChildren<{
  title: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}>;

export function SectionCard({ title, subtitle, action, className, children }: SectionCardProps) {
  return (
    <section className={clsx('section-card', className)}>
      <header className="section-card-header">
        <div>
          <h2>{title}</h2>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        {action ? <div>{action}</div> : null}
      </header>
      {children}
    </section>
  );
}
